import type { FaireProductEntity } from "../../entity_types/product";

export const p_sz45g4fgte: FaireProductEntity = {
  token: "p_sz45g4fgte",
  type: "product",
  name: "STARRY NIGHT Tin & Spoon - Organic, Fair-Trade, Herbal Tea",
  brandToken: "b_cwa13pfnx9",
  brandName: "JusTea (No Import Fees to USA)",
  imageUrl:
    "https://cdn.faire.com/fastly/5c22983f6623c0fdc2ff07b87aa7def45c925c0c9e1fa739a0898ec47fd76756.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b32bc1d719d17c1f1e7103569a10c2895b396926b5cba4a9cb2aa1d469ec2437.jpeg",
    "https://cdn.faire.com/fastly/eb28f57b9ba76ee39c586b405ce8408fc555455cbb95110f83621b44da9c5fd7.jpeg",
    "https://cdn.faire.com/fastly/1a6692d47a44f66558f3c95bdd2c693f68703281eaea12a33caa74a4221dd4c1.jpeg",
    "https://cdn.faire.com/fastly/ecc37b8494562ff601f3dc5a535ab7a56541c3873bf67d8baafdb06fdeeca2f4.jpeg",
    "https://cdn.faire.com/fastly/9964b696df68d4fd9c60eae84de08ab5c86822bb67e340c45fb4cade77e91922.jpeg",
    "https://cdn.faire.com/fastly/b325b925188f909d175946815b1455978df990c00dbaf9449f242fbca354c147.jpeg",
    "https://cdn.faire.com/fastly/88379377b284b8d1698e6dabe74e040031008fe38240ea3170825aa34b9ce43d.jpeg",
  ],
  priceDollars: 9.29,
  description:
    "HOLIDAY FAVE: Starry Night is a calming caffeine-free herbal blend with notes of lavender and lemongrass. Only available for a limited time!\n\nWHY CUSTOMERS LOVE JUSTEA: Award-winning taste, stand-out packaging, and a farmer-direct story!\n\nSTAND-OUT PACKAGING: Beautiful tea tins with the farmer's picture/profile, hand-carved Kenyan spoon, and a viewing window in the lid.\n\nFARMER-DIRECT STORY: Every purchase directly supports small-scale Kenyan tea farmers. Justly Made Tea.\n\nHAND-CARVED SPOON: Attached to each tin is a handcrafted, olive-wood tea spoon! Creating sustainable employment for Kenyan artisans.\n\nEARTH-FRIENDLY: Each tin is recyclable or reusable and offers up to 80 cups of loose leaf tea.\n\nHAND-PICKED TEA from Kenya: Organically grown, free of chemicals and pesticides. Non-GMO. Proud member of Fair Trade Federation.\n\n100% NATURAL INGREDIENTS: Lemongrass, Lavender, Licorice Root, Ginger, Lemon Peel, Orange Peel, Sarsaparilla (Gluten/Sugar-Free and Caffeine-Free).\n\nThe perfect Christmas Gift, Holiday Gift, Stocking Stuffer, for Holiday 2025 / Christmas 2025",
  tags: [],
  msrpDollars: 15.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:56.869Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
